var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.222 23.778a1 1 0 0 1 0-1.414L22.364 8.222a1 1 0 1 1 1.414 1.414L9.636 23.778a1 1 0 0 1-1.414 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.778 23.778a1 1 0 0 1-1.414 0L8.222 9.636a1 1 0 1 1 1.414-1.414l14.142 14.142a1 1 0 0 1 0 1.414"
  })));
};
export default SvgClose;